import { isValidElement } from 'react';
import VisuallyHidden from '@atlaskit/visually-hidden';
export var getIfVisuallyHiddenChildren = function getIfVisuallyHiddenChildren(children) {
  return children && /*#__PURE__*/isValidElement(children) && children.type === VisuallyHidden;
};